import { MOCK_COMPANIES, getCompanyById } from "./mockCompanies";

/**
 * Repositorio de empresas emisoras.
 * Interfaz preparada para reemplazo por Supabase.
 */
export const issuerCompanyRepository = {
	async list() {
		return [...MOCK_COMPANIES];
	},

	async getById(id) {
		return getCompanyById(id);
	},
};
